import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InformationBanner from 'src/components/shared/InformationBanner';
import { MFA_SETTINGS_PATH, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
const today = () => new Date().toDateString();

// { [accountId]: day }, so accounts sharing a browser keep their own dismissal.
const readDismissals = () => {
  try {
    const value = JSON.parse(localStorage.getItem(USER_SETTINGS_KEYS.mfaReminderDismissed));
    return value && typeof value === 'object' ? value : {};
  } catch (_unused) {
    return {};
  }
};

/**
 * Waits for the profile: until GET /account resolves, mfaEnabled reads as its default false, and
 * showing the banner then would nag every user who already has two-factor on.
 */
export const MfaReminderBanner = observer(() => {
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(readDismissals),
    _useState2 = _slicedToArray(_useState, 2),
    dismissals = _useState2[0],
    setDismissals = _useState2[1];
  const profile = store.account.userProfile;
  const isProfileLoaded = store.account.getProfileAsync.hasEverBeenRun && !!profile.id;
  const isDismissedToday = dismissals[profile.id] === today();
  const handleCross = () => {
    // Keep only today's entries, so the record never outgrows the accounts that used this browser today.
    const day = today();
    const next = Object.fromEntries(Object.entries(dismissals).filter(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];
      return value === day;
    }));
    next[profile.id] = day;
    localStorage.setItem(USER_SETTINGS_KEYS.mfaReminderDismissed, JSON.stringify(next));
    setDismissals(next);
  };
  if (!isProfileLoaded || profile.mfaEnabled || !profile.isUserPmRegularOrHigher || isDismissedToday) return null;
  return /*#__PURE__*/React.createElement(InformationBanner, {
    type: "warning",
    title: t('mfa.reminder_title')
    // Wrapped in <p> to pick up the banner body's paragraph typography.
    ,
    text: "<p>".concat(t('mfa.reminder_body'), "</p>"),
    btnLink: MFA_SETTINGS_PATH,
    btnTitle: t('mfa.reminder_cta'),
    btnTarget: "_self",
    handleCross: handleCross
  });
});